import { SIGN_IN, SIGN_UP } from 'actions/auth'
import { CREATE_TRANSFER } from 'actions/transfers'
import update from 'immutability-helper'
import { REFRESH_USER_DATA } from 'actions/users' // TODO: We'll want a more specific action for this
import { CONFIRM_TITHE } from 'actions/tithes'
import { START_ROUNDUPS, STOP_ROUNDUPS, START_TITHING, STOP_TITHING } from 'actions/campaigns'

const setCampaigns = (state, action) => getCampaigns(action)

function getCampaigns(action) {
  return action.payload.data.entities.campaigns
}

function setCurrentSupporterCount(state, { payload: { data: { result, entities: { campaigns } } } }) {
  const { currentSupporterCount } = campaigns[result]

  return update(state, { [result]: { currentSupporterCount: { $set: currentSupporterCount } } })
}

function updateCampaignsTransferableDonationsSums(state, action) {
  const { data: { entities: { transfers }, result: transferId } } = action.payload
  const { grossAmount: transferGrossAmount, campaignId } = transfers[transferId]
  const { transferableDonationsSum }  = state[campaignId]
  const newTransferrableDonationSum = transferableDonationsSum - transferGrossAmount

  return update(state, { [campaignId]: { transferableDonationsSum: { $set: newTransferrableDonationSum } } })
}

function confirmTithe(state, action) {
  const campaigns = { ...state }
  const donations = Object.values(action.payload.data.entities.donations)
  donations.forEach(({ campaignId, amount }) => {
    const campaign = campaigns[campaignId]
    campaign.totalDonationsSum = (+campaign.totalDonationsSum + +amount).toFixed(2)
  })
  return campaigns
}

const handlers = {
  [`${SIGN_IN}_FULFILLED`]: setCampaigns,
  [`${SIGN_UP}_FULFILLED`]: setCampaigns,
  [`${REFRESH_USER_DATA}_FULFILLED`]: setCampaigns,
  [`${CREATE_TRANSFER}_FULFILLED`]: updateCampaignsTransferableDonationsSums,
  [`${CONFIRM_TITHE}_FULFILLED`]: confirmTithe,
  [`${START_ROUNDUPS}_FULFILLED`]: setCurrentSupporterCount,
  [`${STOP_ROUNDUPS}_FULFILLED`]: setCurrentSupporterCount,
  [`${START_TITHING}_FULFILLED`]: setCurrentSupporterCount,
  [`${STOP_TITHING}_FULFILLED`]: setCurrentSupporterCount
}

export default function campaignsReducer(state = {}, action) {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}
